import {
  base_colorContentBorder,
  base_colorRaisedSurface,
  text_colorTextPrimary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_size_3xl,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

const LIST_WIDTH = '420px'
const TOPBAR_HEIGHT = '72px'

export default css`
  height: calc(100vh - ${TOPBAR_HEIGHT});

  .Activity-list {
    width: ${LIST_WIDTH};
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    border-right: 1px solid ${base_colorContentBorder};
    background: ${base_colorRaisedSurface};
  }

  .Activity-list-header {
    display: flex;
    flex-direction: row;
    padding: ${spacing(5)};
    justify-content: space-between;
  }

  .Activity-list-title {
    font-family: ${font_family_weight_medium};
    font-size: ${font_size_3xl};
    line-height: 30px;
    color: ${text_colorTextPrimary};
  }

  .Activity-details {
    padding: ${spacing(10)} ${spacing(20)};
    flex: 1 0 0;
    align-self: stretch;
    overflow: scroll;
  }
`
